import React, { useEffect, useState } from "react";
import {
  getDownloadURL,
  ref,
  uploadBytesResumable,
  uploadBytes,
  deleteObject,
} from "@firebase/storage";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  increment,
} from "firebase/firestore";
import { db, functions } from "../../../Firebase";
import { httpsCallable } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { Timestamp } from "firebase/firestore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import "./createQuiz.css";
import { ExpandMoreSharp } from "@mui/icons-material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { MdEdit, MdDelete } from "react-icons/md";
import { ExpandMoreSvg } from "./icons";
import DeleteLesson from "./lessonDeletePopUp";
import { IP } from "../../../config";
import axios from "axios";
import { getCookie } from "../../../Cookies";
const CreateMcqQuestion = ({
  quizId,
  questionData,
  editQuestion,
  setfetchDataFromApi,
  fetchDataFromApi,
  flagForSeconstEdit,
}) => {
  const storage = getStorage();

  const createQuestion = httpsCallable(functions, "createQuestion");
  const addQuestionSetOrder = httpsCallable(functions, "addQuestionSetOrder");
  //addQuestionSetOrder
  // added by Himanshu
  const [deleteQuestionId, setDeleteQuestionId] = useState("");
  const [openLessonPopUp, setopenLessonPopUp] = useState(false);

  const [questionName, setQuestionName] = useState("");
  const [questionId, setQuestionId] = useState("");

  const initialList = [];
  const [list, setList] = useState(initialList);

  const [trueFalse, setTrueFalse] = useState(false);

  const [fillUpsAns, setFillUpsAns] = useState("");
  // rearrange
  const [canEditRearrange, setCanEditRearrange] = useState(true);
  const [rearrangeOptions, setRearrangeOptions] = useState([
    {
      text: "First",
      position: 1,
    },
    {
      text: "Second",
      position: 2,
    },
    {
      text: "Third",
      position: 3,
    },
    {
      text: "Fourth",
      position: 4,
    },
  ]);
  /* arr element example
    {
      text:"rearrange",
      position: 1
    }
  */

  const [qusMode, setqusMode] = useState("");
  const [qustype, setqustype] = useState("0");
  const [qus, setqus] = useState("");
  const [qusInstruction, setqusInstruction] = useState("");
  const [PointorScore, setPointorScore] = useState("");
  const [qus5, setqus5] = useState({
    option1: "",
    option2: "",
    option3: "",
    option4: "",
  });

  const [checkErrorInForm, setCheckErrorInForm] = useState({
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    questionName: "",
    qusInstruction: "",
    qus: "",
    qus5Answer: "",
  });
  const [qus5Answer, setqus5Answer] = useState("Option 1");
  const [qus2, setqus2] = useState({ word: "", correctImage: "" });
  const [formCheck, setFormCheck] = useState("");
  function submit(e) {
    e.preventDefault();
  }

  const scrambleArr = (arr) => {
    //console.log(arr[0]);
    let res = Array.from(arr);
    return res.sort((a, b) => 0.5 - Math.random());
  };

  const [canEditMatchPair, setCanEditMatchPair] = useState(true);
  const [leftOptions, setLeftOptions] = useState(new Array(4).fill(""));
  const [rightOptions, setRightOptions] = useState([
    {
      text: "",
      match: 1,
    },
    {
      text: "",
      match: 2,
    },
    {
      text: "",
      match: 3,
    },
    {
      text: "",
      match: 4,
    },
  ]);

  const handleMatchPair = (e, order, side) => {
    //console.log("onChange");
    if (!canEditMatchPair) return;
    if (side == "left") {
      setLeftOptions((prev) => {
        let item = e.target.value;

        let res = Array.from(prev);
        res[order - 1] = item;
        return res;
      });
    } else {
      setRightOptions((prev) => {
        let item = {
          text: e.target.value,
          match: order,
        };
        let res = Array.from(prev);
        res[order - 1] = item;
        return res;
      });
    }
  };

  const handleMatchUpScramble = () => {
    setCanEditMatchPair(false);
    setRightOptions((prev) => {
      let res = scrambleArr(prev);
      //console.log(res);
      return res;
    });
  };

  // match words to image

  useEffect(() => {
    if (!editQuestion) return;
    //  console.log(questionData)
    setqus(questionData.data?.question);
    setQuestionName(questionData?.name);
    setQuestionId(questionData?.id);
    setqusInstruction(questionData.data?.questionInstruction);

    if (questionData.data.options) {
      let arr = {};
      for (let i = 0; i < questionData.data.options.length; i++) {
        let op = `option${i + 1}`;
        console.log(op);

        arr[op] = questionData.data.options[i].option;

        if (questionData.data.options[i].iscorrect) {
          setqus5Answer(`Option ${i + 1}`);
        }
        if (i == questionData.data.options.length - 1) {
          setqus5(arr);
        }
      }
    }
  }, [flagForSeconstEdit]);

  const formCheckFunction = () => {
    if (questionName === "") {
      setCheckErrorInForm((prev) => ({ ...prev, questionName: "error" }));
      return "question Name";
    }

    if (qus === "") {
      setCheckErrorInForm((prev) => ({ ...prev, qus: "error" }));
      return "question ";
    }
    if (qusInstruction === "") {
      setCheckErrorInForm((prev) => ({ ...prev, qusInstruction: "error" }));
      return "question ";
    }

    if (qus5.option1 === "") {
      setCheckErrorInForm((prev) => ({ ...prev, option1: "error" }));
      return "question option1";
    }
    if (qus5.option2 === "") {
      setCheckErrorInForm((prev) => ({ ...prev, option2: "error" }));
      return "question option2";
    }
    if (qus5.option3 === "") {
      setCheckErrorInForm((prev) => ({ ...prev, option3: "error" }));
      return "question option3";
    }
    if (qus5.option4 === "") {
      setCheckErrorInForm((prev) => ({ ...prev, option4: "error" }));
      return "question option4";
    }
    if (qus5Answer === "") {
      setCheckErrorInForm((prev) => ({ ...prev, qus5Answer: "error" }));
      return "question Answer";
    }

    return "alliswell";
  };

  async function saveOrder(items) {
    var orderList = [];
    for (let i = 0; i < items.length; i++) {
      orderList.push(items[i].id);
    }
    let configCreateExtraInfo = {
      method: "patch",
      // params: { questionSetId: quizId },
      url: `${IP}/courseBuilder/question`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: JSON.stringify({
        questionPoolAssociated: quizId,
        questionarr: orderList,
        edit: true,
      }),
    };
    await axios(configCreateExtraInfo);

    // addQuestionSetOrder({
    //   questionSetId: quizId,
    //   questions: orderList,
    //   edit: true,
    // });
  }

  const storedDataOnFirebase = async () => {
    let check = formCheckFunction();

    let nsn = questionName.replaceAll(" ", "");

    let dat = /\//i.test(nsn);

    if (!dat) {
    } else {
      alert("you can not use any (/) characters");
      return;
    }
    if (check != "alliswell") {
      setFormCheck("check");
      return;
    }

    setFormCheck("");
    let questionTypeEnum;
    let managequestionData;

    if (qustype == "0") {
      let setoptionFromuser;
      if (qus5Answer == "Option 1") {
        let optionsFromUser = [
          { iscorrect: true, option: qus5.option1 },
          { iscorrect: false, option: qus5.option2 },
          { iscorrect: false, option: qus5.option3 },
          { iscorrect: false, option: qus5.option4 },
        ];
        setoptionFromuser = optionsFromUser;
      } else if (qus5Answer == "Option 2") {
        let optionsFromUser = [
          { iscorrect: false, option: qus5.option1 },
          { iscorrect: true, option: qus5.option2 },
          { iscorrect: false, option: qus5.option3 },
          { iscorrect: false, option: qus5.option4 },
        ];
        setoptionFromuser = optionsFromUser;
      } else if (qus5Answer == "Option 3") {
        let optionsFromUser = [
          { iscorrect: false, option: qus5.option1 },
          { iscorrect: false, option: qus5.option2 },
          { iscorrect: true, option: qus5.option3 },
          { iscorrect: false, option: qus5.option4 },
        ];
        setoptionFromuser = optionsFromUser;
      } else if (qus5Answer == "Option 4") {
        let optionsFromUser = [
          { iscorrect: false, option: qus5.option1 },
          { iscorrect: false, option: qus5.option2 },
          { iscorrect: false, option: qus5.option3 },
          { iscorrect: true, option: qus5.option4 },
        ];
        setoptionFromuser = optionsFromUser;
      }
      let questionDatafromUser = {
        options: setoptionFromuser,
        question: qus,
        questionInstruction: qusInstruction,
      };
      managequestionData = questionDatafromUser;

      questionTypeEnum = 5;
    }
    const docData = {
      questionName: questionName,
      questionId: questionId,
      associatedQuiz: quizId,
      questionSet: quizId,
      questionData: managequestionData,
      questionType: qustype,
      created: Timestamp.now(),
    };
    //console.log(docData);

    let configCreateExtraInfo = {
      method: "post",
      // params: { questionSetId: quizId },
      url: `${IP}/courseBuilder/question`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: JSON.stringify({
        questionId: questionId,
        questionName: questionName,
        questionType: qustype,
        created: new Date().toString(),
        questionData: managequestionData,
        questionPoolAssociated: quizId,
      }),
    };
    axios(configCreateExtraInfo).then((res) => {
      alert("data saved successfully");
      setfetchDataFromApi(fetchDataFromApi + 1);
    });

    toggleQuestionForm();

    document.getElementById(quizId + "question-form").reset();
    document.getElementById(quizId + "questionName").value = "";
  };

  const toggleQuestionForm = (e) => {
    resetData();
    document.getElementById(quizId + "questionForm").style.display =
      document.getElementById(quizId + "questionForm").style.display == "none"
        ? "block"
        : "none";
  };
  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(list);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setList(items);
    saveOrder(items);
  }

  function edit(lesson) {
    toggleQuestionForm();
  }

  function resetData() {
    setQuestionName("");
    setQuestionId("");
    setqustype("0");
    setqus("");
    setqusInstruction("");
    setRearrangeOptions([
      {
        text: "First",
        position: 1,
      },
      {
        text: "Second",
        position: 2,
      },
      {
        text: "Third",
        position: 3,
      },
      {
        text: "Fourth",
        position: 4,
      },
    ]);
    setqus5({
      option1: "",
      option2: "",
      option3: "",
      option4: "",
    });
    setqus5Answer("Option 1");
  }
  async function del(question) {
    setopenLessonPopUp(true);
    setDeleteQuestionId(question);
  }

  return (
    <section className="quizForm-container">
      <form id={quizId + "question-form"} onSubmit={submit}>
        <div className="quizForm-mainForm-infoRow">
          <p className="quizForm-mainForm-label">Question Name :</p>
          <input
            type="text"
            className="quizForm-mainForm-inputBar"
            value={questionName}
            id={quizId + "questionName"}
            style={{
              border: `${
                checkErrorInForm.questionName == "error"
                  ? "2px solid red"
                  : "1px solid #d7d7d7"
              }`,
            }}
            onChange={(e) => {
              setQuestionName(e.target.value);
              setCheckErrorInForm((prev) => ({ ...prev, questionName: "" }));
              let value = e.target.value.replaceAll(" ", "");
              let time = new Date().getTime();
              if (!editQuestion) {
                setQuestionId(value + "_" + time);
              }
            }}
          />

          {checkErrorInForm.questionName == "error" && (
            <span
              style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
            >
              Enter Question Name
            </span>
          )}
        </div>

        <div className="quizForm-mainForm-infoRow">
          <label className="quizForm-mainForm-label">Question : </label>
          <textarea
            className="quizForm-mainForm-textarea"
            value={qus}
            style={{
              border: `${
                checkErrorInForm.qus == "error"
                  ? "2px solid red"
                  : "1px solid #d7d7d7"
              }`,
            }}
            onChange={(event) => {
              setqus(event.target.value);
              setCheckErrorInForm((prev) => ({ ...prev, qus: "" }));
            }}
          ></textarea>

          {checkErrorInForm.qus == "error" && (
            <span
              style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
            >
              Enter Question
            </span>
          )}
        </div>
        <div className="quizForm-mainForm-infoRow">
          <label className="quizForm-mainForm-label">Instruction : </label>
          <textarea
            className="quizForm-mainForm-textarea"
            value={qusInstruction}
            style={{
              border: `${
                checkErrorInForm.qusInstruction == "error"
                  ? "2px solid red"
                  : "1px solid #d7d7d7"
              }`,
            }}
            onChange={(event) => {
              setqusInstruction(event.target.value);
              setCheckErrorInForm((prev) => ({ ...prev, qusInstruction: "" }));
            }}
          ></textarea>

          {checkErrorInForm.qusInstruction == "error" && (
            <span
              style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
            >
              Enter Question Instruction
            </span>
          )}
        </div>

        {qustype == "0" ? (
          <>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 1 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                name="text"
                value={qus5.option1}
                placeholder="Enter Option"
                style={{
                  border: `${
                    checkErrorInForm.option1 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                onChange={(event) => {
                  setqus5({ ...qus5, option1: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option1: "" }));
                }}
              />
              {checkErrorInForm.option1 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option1
                </span>
              )}
            </div>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 2 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                name="text"
                value={qus5.option2}
                style={{
                  border: `${
                    checkErrorInForm.option2 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                placeholder="Enter Option"
                onChange={(event) => {
                  setqus5({ ...qus5, option2: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option2: "" }));
                }}
              />

              {checkErrorInForm.option2 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option2
                </span>
              )}
            </div>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 3 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                name="text"
                value={qus5.option3}
                style={{
                  border: `${
                    checkErrorInForm.option3 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                placeholder="Enter Option"
                onChange={(event) => {
                  setqus5({ ...qus5, option3: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option3: "" }));
                }}
              />

              {checkErrorInForm.option3 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option3
                </span>
              )}
            </div>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">Option 4 : </label>
              <input
                className="quizForm-mainForm-inputBar"
                type="text"
                value={qus5.option4}
                style={{
                  border: `${
                    checkErrorInForm.option4 == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                placeholder="Enter Option"
                onChange={(event) => {
                  setqus5({ ...qus5, option4: event.target.value });
                  setCheckErrorInForm((prev) => ({ ...prev, option4: "" }));
                }}
              />
              {checkErrorInForm.option4 == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question option4
                </span>
              )}
            </div>
            <div className="quizForm-mainForm-infoRow">
              <label className="quizForm-mainForm-label">
                {" "}
                Choose the correct Option :{" "}
              </label>
              <select
                className="quizForm-mainForm-select"
                value={qus5Answer}
                style={{
                  border: `${
                    checkErrorInForm.qus5Answer == "error"
                      ? "2px solid red"
                      : "1px solid #d7d7d7"
                  }`,
                }}
                onChange={(event) => {
                  setqus5Answer(event.target.value);
                  setCheckErrorInForm((prev) => ({ ...prev, qus5Answer: "" }));
                }}
              >
                <option value="Option 1">Option 1</option>
                <option value="Option 2">Option 2</option>
                <option value="Option 3">Option 3</option>
                <option value="Option 4">Option 4</option>
              </select>

              {checkErrorInForm.qus5Answer == "error" && (
                <span
                  style={{ marginLeft: "20px", color: "red", fontSize: "15px" }}
                >
                  Enter Question Answer
                </span>
              )}
            </div>
          </>
        ) : (
          " "
        )}
      </form>
      {formCheck && <div> Fill all the Required fields.</div>}
      <div className="quizForm-mainForm-infoRow">
        <button
          className="quizFrom-button"
          style={{ marginLeft: "auto" }}
          onClick={storedDataOnFirebase}
        >
          Submit
        </button>
      </div>
    </section>
  );
};

export default CreateMcqQuestion;
